import LegalLayout from './LegalLayout';

export default function PrivacyPage() {
  return (
    <LegalLayout title="隐私政策">
      <p>本平台会收集被统计网站的访问页面、来源、设备信息和 IP，用于生成流量报表。</p>
      <p>账号密码在浏览器本地以哈希形式保存。Access Token 用于读取你自己的站点概览，请勿泄露。</p>
      <p>我们不会把你的站点访问明细出售给第三方。如需停止采集，可在网站配置中停用或删除站点。</p>
    </LegalLayout>
  );
}
